import {
  Box,
  Paper,
  Title,
  createStyles,
  Center,
  Loader,
  UnstyledButton,
  Button,
  MultiSelect,
  Modal,
} from "@mantine/core";

import { Pagination } from "@mantine/core";

import { CustomTable } from "../../components/Table";

import { forwardRef, useEffect, useState } from "react";
import { useMedplum } from "@medplum/react";
import {
  mapAuditEvents,
  mapStatusToOutcome,
  searchResource,
} from "./AuditService";
import Buttonfilter from "../../assets/img/Icon Button.svg";
import { PatientNotFound } from "../Patient/PatientVisits/DataNotFound";

const useStyles = createStyles(() => ({
  default: {
    borderRadius: "8px",
    marginLeft: "40px",
    marginRight: "40px",
    height: "100%",
    padding: "16px",
    marginTop: "16px",
  },
  createVideoAppointment: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
}));

export const Audit = () => {
  const { classes } = useStyles();
  const medplum = useMedplum();
  const [Resource, setAuditResource] = useState<any>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState<any>("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [status, setStatus] = useState<string[]>([]);
  const [outcome, setOutcome] = useState<any>();

  const [isloading, setisLoading] = useState<boolean>(false);

  useEffect(() => {
    auditResource(1);
  }, []);

  const auditResource = (PageNumber: number,filter?:boolean,status?:any) => {

    setisLoading(true);

    let count = 20;
    let queryString
    let resourceType;
    if(filter){
      queryString = `_count=${count}&_offset=${
        (PageNumber - 1) * count
      }&_sort=-_lastUpdated&_total=accurate&outcome=${status}`;
       resourceType = "AuditEvent";
    }else{
     queryString = `_count=${count}&_offset=${
      (PageNumber - 1) * count
    }&_sort=-_lastUpdated&_total=accurate`;
     resourceType = "AuditEvent";
  }

    searchResource(medplum, resourceType, queryString).then((res: any) => {
      const totalData = Math.ceil((res.bundle.total as any) / 20);
      setTotal(totalData);

      const mappedAudit = mapAuditEvents(res);
      setAuditResource(mappedAudit);
      setisLoading(false);
    });
  };
  
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    // auditResource(page);
    if(status.length>0){
          auditResource(page,true,outcome);

    }else{
          auditResource(page);

    }
  };
  const handleChange = (selectedStatus: string[]) => {
    // auditResource(currentPage);

    const lowercaseStatus = selectedStatus.map((status) =>
      status.toLowerCase()
    );

    setStatus(lowercaseStatus);

  };
  const statusToOutcomeMap: any = {
    "Show All":[0,4,8,12],
    Success: 0,
    "Minor Failure": 4,
    "Serious Failure": 8,
    "Major Failure": 12,
  };

  const handleApply = () => {
    // Extract the outcome values from status
    if(status.length===0){
      const data=    auditResource(1,false);
      setAuditResource(data)
          setCurrentPage(1)
              setIsModalOpen(false);


    }else{

    const mappedStatusArray = status.map(mapStatusToOutcome);
    setOutcome(mappedStatusArray)

    // consfilteredData = Resource.filter((e: any) => {
    //   return mappedStatusArray?.includes(e?.outcome);
    // });
    const filteredData = auditResource(1,true,mappedStatusArray);

    setAuditResource(filteredData);
    setIsModalOpen(false);
    }
    // Store or use the filteredData as needed
  };
  const capitalizedFilter = status.map((s: string) => {
    const words = s.split(" ");
    const capitalizedWords = words.map((word: string) => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
    return capitalizedWords.join(" ");
  });
  return (
    <>
      {" "}
      <Paper className={classes.default}>
        <Box sx={{}}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  gap: "12px",
                }}
              >
                <Title
                  sx={{
                    fontWeight: 700,
                    fontSize: "26px",
                    lineHeight: "36px",
                    color: "#262930",
                    marginBottom: "30px",
                  }}
                >
                  Audit Events
                </Title>
                <Box>
                  <UnstyledButton onClick={() => setIsModalOpen(true)}>
                    <Box>
                      <img
                        src={Buttonfilter}
                        style={{ height: "40px", width: "40px" }}
                      />
                    </Box>
                  </UnstyledButton>
                </Box>
              </Box>
            </Box>
            {/* table */}
            <Box>
              <Box sx={{ paddingBottom: "16px" }}>
                {isloading ? (
                  <Center className={classes.createVideoAppointment}>
                    <Loader />
                  </Center>
                ) : (
                  <>
                    <Box>
                      <CustomTable
                        showActionColumn={false}
                        head={[
                          "Id",
                          "Agent",
                          "Entity",
                          "Outcome",
                          "Outcome Desc",

                          "Recorded",
                        ]}
                        data={Resource}
                      />
                        <Box
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Pagination
                            total={total}
                            onChange={handlePageChange}
                            defaultValue={currentPage}
                          />
                        </Box>
                     
                    </Box>
                    {Resource.length === 0 && (
                      <Box mt={90}>
                        <PatientNotFound
                          patient={`Selected ${[...capitalizedFilter] as any} filter`}
                        />
                      </Box>
                    )}
                  </>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
        <Modal
          opened={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          size="md"
          withCloseButton={false}
        >
          <Box sx={{ paddingTop: "20px", minHeight: "225px" }}>
            <MultiSelect
              data={[
                "Success",
                "Major Failure",
                "Minor Failure",
                "Serious Failure",
                "Show All"
              ]}
              label="Choose status for filter"
              placeholder="Select filter"
              nothingFound="Nothing found"
              maxDropdownHeight={125}
              dropdownPosition="bottom"
              onChange={handleChange}
              defaultValue={[...capitalizedFilter]}
              clearable={true}
            />
          </Box>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button disabled={isloading ? true : false} onClick={handleApply}>
              Apply
            </Button>
          </Box>

          {/* Add modal content here */}
        </Modal>
      </Paper>
    </>
  );
};
